<template>
  <splide
    :slides="payload"
    :options="settings"
    @splide:mounted="onMounted"
  >
    <splide-slide v-for="(slide,s) in payload" :key="s">
      <component :is="type" :payload="slide"></component>
    </splide-slide>
  </splide>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import Resource from './Resource';
import Event from './Event';

export default {
  components: {
    Splide,
    SplideSlide,
    Resource,
    Event
  },

  props: {
    type: {
      type: String,
    },
    payload: {
      type: Object
    },
    settings: {
      type: Object,
      default: {
        type: 'loop', // slide/loop/fade
        autoplay: true,
        rewind: true,
        rewindSpeed: 1000,
        interval: 5000,
        width: '100%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        perPage: 4,
        breakpoints: {
          // 480: {
          //   perPage: 1,
          // },
          640: {
            perPage: 1,
          },
          768: {
            perPage: 2,
          },
          1024: {
            perPage: 3,
          },
          1280: {
            perPage: 4,
          },
          1536: {
            perPage: 5,
          },
        }
      }
    }
  },

  data() {
    return {
    }
  },

  methods: {
    onMounted(splide) {
      console.log('Splide mounted:', splide);
    },
  },
};
</script>
